import { useState } from "react"
import { Button } from "./ui/button"
import { Send } from "lucide-react"
import { EmailModal } from "./EmailModal"
import useSendMailToCustomer from "@/hooks/api/use-send-mail-to-customer"
import { useParams } from "react-router-dom"
import { useToast } from "./ui/use-toast"

export default function SendEmailToCustomerButton({
  customerName,
  customerEmail,
  disabled = false,
}: {
  customerName: string
  customerEmail: string
  disabled?: boolean
}) {
  const { councilId, customerId } = useParams()
  const [emailModalOpen, setEmailModalOpen] = useState(false)
  const { toast } = useToast()

  const { mutate: sendEmail, isPending } = useSendMailToCustomer({
    onSuccess: () => {
      setEmailModalOpen(false)
      toast({
        title: "Email Sent",
        description: `An email has been sent to ${customerName}.`,
      })
    },
    onError: (error: Error) => {
      toast({
        title: "Error Sending Email",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const handleSendEmail = (subject: string, message: string) => {
    sendEmail({
      councilId: councilId || "",
      customerId: customerId || "",
      req: { subject, message },
    })
  }

  return (
    <div className="flex items-center gap-4 mb-6">
      <Button className="flex-1" onClick={() => setEmailModalOpen(true)} disabled={disabled || isPending}>
        <Send className="size-4 mr-2" />
        {isPending ? "Sending..." : "Send Email"}
      </Button>
      <EmailModal
        open={emailModalOpen}
        onOpenChange={setEmailModalOpen}
        customerEmail={customerEmail}
        customerName={customerName}
        onSend={handleSendEmail}
        isLoading={isPending}
      />
    </div>
  )
}
